jQuery(document).ready(function() {
	menu();
	faq();
	tab();
	darkblueBGslider();
	threeColSlider();
	productSlider();
	wowo(jQuery);
	video();
	viewGoTo();
	bannerProductTab();

}).on('click', '[href="#contact"]', function(){
	$('[data-drawer="contact"]').addClass('in')
  	return false;
}).on('click', '[href="#resources"]', function(){
	$('[data-drawer="resources"]').addClass('in')
  	return false;
}).on('click', '.menu-custom-drawer', function(e){
  	
  	if($(e.target).is('.menu-custom-drawer') || $(e.target).is('.menu-custom-drawer-close') || $(e.target).closest('.menu-custom-drawer-close').length){
    	$('.menu-custom-drawer').removeClass('in')
    }
});
window.onload = function () {
   normalProducts();
}
jQuery(window).scroll(function() {
	wowo(jQuery);
});
jQuery(window).resize(function() { 
	
});
function wowo($) {
	var wTop = jQuery(window).scrollTop(), 
		wHeight = jQuery(window).height(), 
		wBottom = wTop + wHeight;
	jQuery(".wowo:not(.animated)").each(function () {
			var me = jQuery(this), meTop = me.offset().top, 
			meHeight = me.innerHeight(), 
			meBottom = meTop + meHeight,
			limitTop = wTop - meHeight, 
			limitBottom = wBottom + meHeight;
			if (meTop > limitTop && meBottom < limitBottom) {
				me.addClass("animated");
			}
	});
}

function normalProducts(){
	if(!jQuery('.mw-apo-container').length){
		// console.log('normal product');
		//jQuery('.product-form__quantity').removeClass('hidden');
		jQuery('.price-row, variant-radios').removeClass('hidden');
		
	}
}

function bannerProductTab(){
	var height = 0;
	jQuery(".product-box-after-hero .tab-box").each(function(){
		if(jQuery(this).innerHeight()>=height){
			height = jQuery(this).innerHeight();
			jQuery(this).css('min-height',height);
		}else{
			jQuery(this).css('min-height',height);
		}
	});
	
	
	jQuery(".hero-banner .tab-list li a").click(function(){
		var index = jQuery(this).parent().index();
		jQuery(this).parent().siblings().removeClass('active');
		jQuery(this).parent().addClass('active');
		jQuery(this).parents('.products-box').find('.tab-box').removeClass('is-active');
		jQuery(this).parents('.products-box').find('.tab-box').eq(index).addClass('is-active');
	});
	jQuery(".product-box-after-hero .tab-list li a").click(function(){
		var index = jQuery(this).parent().index();
		jQuery(this).parent().siblings().removeClass('active');
		jQuery(this).parent().addClass('active');
		jQuery(this).parents('.product-box-after-hero').find('.tab-box').removeClass('is-active');
		jQuery(this).parents('.product-box-after-hero').find('.tab-box').eq(index).addClass('is-active');
	});	
}


function viewGoTo(){
	jQuery(".hero-banner .row-box ul li a").click(function(){
		var id = jQuery(this).attr('href').substr(1);
		jQuery("section").each(function(){
			var myid = jQuery(this).attr('data-id');
			if(myid==id){
				var moduleH = jQuery(this).offset().top;
				var headerH = jQuery('header').innerHeight();
				jQuery('html,body').stop().animate({scrollTop:moduleH - headerH},500);
			}
		});
	})	
		
}

function video(){
    jQuery(".play-btn").click(function(event){
        event.preventDefault();
        jQuery(document).bind("mousewheel DOMMouseScroll",function(event){event.preventDefault()});
        jQuery(document).bind("touchmove",function(event){event.preventDefault()});
        jQuery('.video-light-box').fadeIn(300);
        var html = jQuery(this).siblings('.data-video').html();
        jQuery('.video-light-box').find('.play-iframe-video').html(html);
    });
    jQuery('.video-light-box .close').click(function(){
        jQuery(document).unbind("mousewheel DOMMouseScroll");
        jQuery(document).unbind("touchmove");
        jQuery('.video-light-box').fadeOut(300);
        setTimeout(function(){
            jQuery('.video-light-box').find('.play-iframe-video').html('');
        },300);
    });
    jQuery('.video-light-box').click(function(){
        jQuery(document).unbind("mousewheel DOMMouseScroll");
        jQuery(document).unbind("touchmove");
        jQuery('.video-light-box').fadeOut(300);
        setTimeout(function(){
            jQuery('.video-light-box').find('.play-iframe-video').html('');
        },300);
    });
    jQuery('.video-light-box .video-box').click(function(event){
        event.stopPropagation();
    });
}

function tab() {
	jQuery('.tab-btns ul li button').click(function() { 
		if(!jQuery(this).parent().hasClass('active')){
			var index = jQuery(this).parent().index();
			jQuery(this).parent().siblings().removeClass('active');
			jQuery(this).parent().addClass('active');
			jQuery('.tab-content').siblings().hide();
			jQuery('.tab-content').eq(index).fadeIn();
		}
	});
}

function faq() {
	jQuery('.faq-title').click(function() { 
		jQuery(this).parent('.faq-item').siblings().find('.faq-title').removeClass('open');
		jQuery(this).parent('.faq-item').siblings().find('.faq-content').slideUp();
		jQuery(this).toggleClass('open');
		jQuery(this).siblings('.faq-content').slideToggle();
	});
}


function menu() {
	jQuery('.hamburger-btn').click(function() { 
		jQuery(this).toggleClass('open');
		jQuery('.header__icon--menu').trigger('click');
	});
	jQuery('#MainContent').click(function() {
		if(jQuery('#Details-menu-drawer-container').hasClass('menu-opening')){
			jQuery('.hamburger-btn').removeClass('open');
			jQuery('.header__icon--menu').trigger('click');
		}
	});
}

function productSlider() {
	jQuery('.product-slider .lager-slider').slick({
		swipe:false,
		touchMove:false,
		fade:false,
		dots: false,
		infinite: true,
		autoplay:true,
		speed:600,
		autoplaySpeed:7000,
		arrows:false,
		slidesToScroll: 1,
		pauseOnHover:false,
		slidesToShow: 1,
		adaptiveHeight: true,
		asNavFor: '.product-slider .nav-slider',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows:false,
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 1,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
	
	jQuery('.product-slider .nav-slider').slick({
		swipe:false,
		touchMove:false,
		fade:false,
		dots: false,
		infinite: true,
		autoplay:true,
		speed:600,
		autoplaySpeed:7000,
		arrows:false,
		slidesToScroll: 1,
		pauseOnHover:false,
		slidesToShow: 3,
		adaptiveHeight: true,
		focusOnSelect: true,
		asNavFor: '.product-slider .lager-slider',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows:false,
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 3,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
}

function darkblueBGslider() {
	jQuery('.img-and-text-slider .slider-wrap').slick({
		swipe:false,
		touchMove:false,
		fade:false,
		dots: true,
		infinite: true,
		autoplay:true,
		speed:600,
		autoplaySpeed:7000,
		arrows:true,
		slidesToScroll: 1,
		pauseOnHover:false,
		slidesToShow: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows:false,
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 1,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
}


function threeColSlider() {
	jQuery('.three-col-slider .slider-wrap').slick({
		swipe:false,
		touchMove:false,
		fade:false,
		dots: false,
		infinite: false,
		autoplay:false,
		speed:600,
		autoplaySpeed:7000,
		arrows:true,
		slidesToScroll: 3,
		pauseOnHover:false,
		slidesToShow: 3,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToScroll: 2,
					slidesToShow: 2,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			},
			{
				breakpoint: 768,
				settings: {
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToScroll: 1,
					slidesToShow: 1,
					cssEase: 'cubic-bezier(0.42, 0, 0.58, 1)',
					touchThreshold:100
				}
			}
		]
	});
}